import React, { forwardRef } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { Snackbar as MuiSnackBar } from '@mui/material';

import { closeSnackbar } from 'store/application';
import { AlertMessage } from './styles';

const Alert = forwardRef(function Alert (props, ref) {
  return <AlertMessage
    elevation={6} ref={ref} variant='filled' {...props}
  />;
});

export const Snackbar = (props) => {
  const { duration } = props;
  const snackbar = useSelector(({ application }) => application.snackbar);
  const dispatch = useDispatch();

  // Handlers
  const handleClose = () => {
    dispatch(closeSnackbar());
  };

  return (
    <MuiSnackBar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={snackbar?.open}
      {...(!snackbar.showAlways ? { autoHideDuration: duration ?? 6000 } : {})}
      onClose={handleClose}
      style={{ minWidth: '280px' }}>
      <Alert
        onClose={handleClose}
        severity={snackbar?.type}
        sx={{ width: '100%' }}>
        {snackbar?.message}
      </Alert>
    </MuiSnackBar>
  );
};

Snackbar.defaultProps = {
  duration : 6000,
};
export default Snackbar;
